import { AxiosPromise } from 'axios'

import api from '@config/api'

export function getCenters(): AxiosPromise {
  return api.get('v1/Loja')
}

export function getCategories(): AxiosPromise {
  return api.get('v1/Categoria')
}

export function getCompanies(): AxiosPromise {
  return api.get('v1/Empresa')
}
export function getCompactCategories(): AxiosPromise {
  return api.get('v1/CategoriaCompacta')
}

export function getCompactCategoriesConfig(): AxiosPromise {
  return api.get('v1/Usuario/Configuracoes/CategoriasCompactas')
}

export function getWorlds(): AxiosPromise {
  return api.get('v1/Mundo')
}

// CONFIGURACAO
export function getCompaniesConfig(): AxiosPromise {
  return api.get('v1/Usuario/Configuracoes/Empresas')
}

export function getCategoryManagersConfig(): AxiosPromise {
  return api.get('v1/Usuario/Configuracoes/Gerente/Categorias')
}

export function getProductManagersConfig(): AxiosPromise {
  return api.get('v1/Usuario/Configuracoes/Gerente/Produtos')
}

export function getCentersConfig(): AxiosPromise {
  return api.get('v1/Usuario/Configuracoes/Lojas')
}

export function getWorldsConfig(): AxiosPromise {
  return api.get('v1/Usuario/Configuracoes/Mundos')
}

//
export function getDistributionCenters(): AxiosPromise {
  return api.get('v1/Loja/CentroDistribuicao')
}

export function getProvidersForPurchase(): AxiosPromise {
  return api.get('v1/Fornecedor')
}

export function getProvidersForDistribution(): AxiosPromise {
  return api.get('v1/Fornecedor')
}

export function getProductsForPurchase(): AxiosPromise {
  return api.get('v1/Produto/Compras')
}

export function getProductsForSupply(): AxiosPromise {
  return api.get('v1/Produto')
}

export function getProductsForDistribution(): AxiosPromise {
  return api.get('v1/Produto/Distribuicoes')
}

export function getProfiles(): AxiosPromise {
  return api.get('v1/Perfil')
}

export function getCategoryManagers(): AxiosPromise {
  return api.get('v1/Gerente/Categorias')
}

export function getProductManagers(): AxiosPromise {
  return api.get('v1/Gerente/Produtos')
}

export function getStatusInventory(): AxiosPromise {
  return api.get('v1/Estoque/Status')
}

// ORÇAMENTO

export function getBudgetYears(): AxiosPromise {
  return api.get('v1/Orcamento/Anos')
}

export function getBudgetMonths(): AxiosPromise {
  return api.get('v1/Orcamento/Meses')
}

export function getBudgetHistorics(): AxiosPromise {
  return api.get('v1/Orcamento/historicos')
}

export function getBudgetOperations(): AxiosPromise {
  return api.get('v1/Orcamento/Operacoes')
}

export function getDeposits(): AxiosPromise {
  return api.get('v1/KPIEstoque/Depositos')
}

export function getPeriods(): AxiosPromise {
  return api.get('v1/OTB/Periodos')
}

export function getConfigMarge(): AxiosPromise {
  return api.get('v1/OrcamentoParametro/MargemMedia/Configuracao')
}

export function putConfigMarge(data: any): AxiosPromise {
  return api.put('v1/OrcamentoParametro/MargemMedia/Configuracao', data, {})
}

export function postLogFront(data: any): AxiosPromise {
  return api.post('v1/Log/UI/Gravar', data, {})
}

export function getPurchaseOrderType(): AxiosPromise {
  return api.get('v1/AcompanhamentoCompra/TiposPedidos')
}

export function getPurchaseOrderTypeReab(): AxiosPromise {
  return api.get('v1/AcompanhamentoReab/TiposPedidosReab')
}

export function getClosingBase(): AxiosPromise {
  return api.get('/v1/KPIEstoque/Periodos')
}

export function getTypeOfAlert(): AxiosPromise {
  return api.get('v1/TypeOfAlert')
}
export function getAction(indexAction: any) {
  let url = '/action'
  if (indexAction === 1) {
    url += '?type=[]=DEV'
  }
  if (indexAction === 2) {
    url += '?type=[]=ACT'
  }

  return url
}

export function getPurchases(): AxiosPromise {
  return api.get('v1/PurchasesFilter')
}

export function getSubCategoria(): AxiosPromise {
  return api.get('v1/SubCategoria')
}

export function getCompradores(): AxiosPromise {
  return api.get('v1/ControleFornecedor/Compradores')
}
export default {
  getCenters,
  getDistributionCenters,
  getCompanies,
  getCategories,
  getCompactCategories,
  getWorlds,
  getProvidersForPurchase,
  getProvidersForDistribution,
  getProductsForPurchase,
  getProductsForSupply,
  getProductsForDistribution,
  getProfiles,
  getCategoryManagers,
  getProductManagers,
  getConfigMarge,
  putConfigMarge,
  getStatusInventory,
  getBudgetYears,
  getBudgetMonths,
  getBudgetHistorics,
  getBudgetOperations,
  getDeposits,
  getPeriods,
  getCompaniesConfig,
  getCategoryManagersConfig,
  getProductManagersConfig,
  getCentersConfig,
  getWorldsConfig,
  getPurchaseOrderType,
  getPurchaseOrderTypeReab,
  postLogFront,
  getClosingBase,
  getTypeOfAlert,
  getPurchases,
  getSubCategoria,
  getCompactCategoriesConfig,
  getCompradores
}
